export const handlerActiveOnly = {
  computed: {
    activeOnly: {
      get() {
        const { activeOnly } = this.$route.query;
        return typeof activeOnly === 'boolean' ? activeOnly : activeOnly === 'true';
      },
      set(activeOnly) {
        const query = { ...this.$route.query, activeOnly };
        this.$router.push({ query }, null, () => {});
      },
    },
  },
};
